export default "__VITE_ASSET__B8c6FUz7__"